import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "el-text__primary" }, " Users "),
  /*#__PURE__*/_createElementVNode("p", null, " Manage Users. ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" customize ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        type: "flex",
        justify: "space-between",
        align: "middle"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_el_button, {
            type: "success",
            icon: "el-icon-s-operation"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: [],
        style: {"width":"100%"},
        border: "",
        stripe: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIndex) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: columnIndex,
              prop: column.prop,
              label: column.label
            }, null, 8, ["prop", "label"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}